import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from '@angular/core';
import { StepStateViewModel } from '../step-header/step-header.component';

@Component({
    selector: 'app-step-footer',
    templateUrl: './step-footer.component.html',
    styleUrls: ['./step-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepFooterComponent implements OnInit {
  readonly state = input<StepStateViewModel>();
  readonly previousTitle = input('Back');
  readonly previousVisible = input(false);
  readonly previousEnabled = input(true);
  readonly nextTitle = input('Next');
  readonly nextVisible = input(true);
  readonly nextEnabled = input(true);

  readonly previousClicked = output<void>();
  readonly nextClicked = output<void>();

  readonly effectivePreviousVisible = signal(false);
  readonly effectiveNextTitle = signal('Next');

  ngOnInit(): void {
    const stateVal = this.state();
    if (stateVal) {
      this.effectivePreviousVisible.set(stateVal.hasPrevious);
      if (stateVal.hasNext) {
        this.effectiveNextTitle.set('Next');
      } else if (stateVal.readonly) {
        this.effectiveNextTitle.set('Close');
      } else {
        this.effectiveNextTitle.set('Finish');
      }
    } else {
      this.effectivePreviousVisible.set(this.previousVisible());
      this.effectiveNextTitle.set(this.nextTitle());
    }
  }

  previous(): void {
    if (this.previousEnabled()) {
      this.previousClicked.emit();
    }
  }

  next(): void {
    if (this.nextEnabled()) {
      this.nextClicked.emit();
    }
  }
}
